import { render, staticRenderFns } from "./PlanFeaturePill.vue?vue&type=template&id=084aaef9"
import script from "./PlanFeaturePill.vue?vue&type=script&lang=js"
export * from "./PlanFeaturePill.vue?vue&type=script&lang=js"
import style0 from "./PlanFeaturePill.vue?vue&type=style&index=0&id=084aaef9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports